<template lang="pug">
  .b-group
    NodeHead._draggable(
      :item="item"
      :draggable="true"
    )
    .b-group__container
      slot
    button.b-group__add(
      v-if="amount < 10"
      type="button"
      @click="addItem"
    )
      font-awesome-icon(
        icon="plus"
        fixed-width
      )
</template>

<script>
import NodeHead from '@/components/node/NodeHead';
import { mapActions } from 'vuex';
import { ELEMENTS_TYPES_GROUPS } from '@/api/elements';

export default {
  name: 'NodesGroup',
  components: { NodeHead },
  props: {
    item: Object,
    amount: [Number, Boolean],
  },
  methods: {
    ...mapActions('nodes', [
      'addNode',
    ]),
    addItem() {
      this.addNode({
        from: this.item.id,
        isNew: true,
        type: ELEMENTS_TYPES_GROUPS[this.item.type],
      });
    },
  },
};
</script>
